<template>
  <div class="event" :style="{backgroundColor: color}">
    <img v-if="image" class="event__bg-img" :src="image" :alt="name">
    <div class="event__container">
      <div class="event__type" :style="{backgroundColor: typeColor}">{{ type }}</div>
      <div class="event__name">{{ name }}</div>
      <div class="event__date">
        {{ dayjs(date).format('DD MMMM YYYY') }}
        <span>-</span>
        {{ dayjs(date).format('dd HH:mm').toUpperCase() }}
      </div>
      <div class="event__actions">
        <a :href="to" class="btn btn_primary">Купить билет </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { computed } from 'vue';
import 'dayjs/locale/ru';

dayjs.extend(utc);
dayjs.locale('ru');

const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  date: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  to: {
    type: String,
    default: '',
  },
});
const typeColor = computed(() => (props.type === 'Шоу' ? '#FFFAE9' : '#E8F6EE'));

</script>

<style scoped lang="scss">
.event {
  border-radius: 20px;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-image: url('../../../../images/site/pattern-concert.svg');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;

  &__type {
    padding: 7px 12px;
    display: inline-block;
    border-radius: 16px;
    font-size: 14px;
    align-self: start;
    justify-self: start;
    min-width: 80px;
    text-align: center;
    color: $deep-gray-blue;
  }

  &__bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: cover;
  }

  &__container {
    background-color: rgba($color: $color, $alpha: .3);
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__name {
    font-size: 32px;
    color: $white;
    font-weight: 700;
    margin-top: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 120%;
  }

  &__date {
    color: $white;
    font-size: 14px;

    span {
      color: $primary;
      font-size: 24px;
      line-height: 16px;
    }
  }

  &__actions {
    a {
      display: inline-block;
      width: 100%;
      text-align: center;
      border-radius: 16px;
      line-height: 128%;
    }
  }
}
</style>
